export const TEAMS_DE = {
    
}